jQuery(function($){
  'use strict'
  console.log("Delivered by: Cobold Digital")
  var headerHeight
  function headerHeight() {
    headerHeight = $('#header').outerHeight(true);
    $('main').css('paddingTop', headerHeight);
  }
  var innerPageNavHeight = $(".innerPageNavigationSection").outerHeight();
  var mobileOnly = window.matchMedia("(max-width: 767px)");
  var tabsOnly = window.matchMedia("(max-width: 991px)");
  //Footer height
  var footerHeight;
  function footerHeight() {
    footerHeight = $("footer").outerHeight(true);
  }

  //Mobile nav height
  if (tabsOnly) {
    var primaryMenuHeight = $("#primary-menu-left").outerHeight();
    $(".menu-main-menu-2-container").css({
      top: primaryMenuHeight,
    });
  }

  // Active Navbar
  function activeNavbar() {
    $(".navLeftRight>div>ul>li>a").each(function () {
      if (this.ariaCurrent) {
        $(this).addClass("active");
      }
    });
  }

  // Locate to other page's specific id
  function toOtherPageSpecificId() {
    var hashcode = window.location.hash;
    if (hashcode && hashcode !== "#null") {
      $("html,body").animate(
        {
          scrollTop:
            $("" + hashcode).offset().top - (headerHeight + innerPageNavHeight),
        },
        "slow"
      );
    }
  }

  //Mobile menu
  function mobileMenu() {
    $(".MenuBar").click(function (e) {
      e.preventDefault();
      $("#header .NavContainer").addClass("Active_Nav");
    });
    $(".MenuOverlay").click(function (e) {
      e.preventDefault();
      $("#header .NavContainer").removeClass("Active_Nav");
    });
  }

  function currentLocation() {
    var url = window.location.href;
    var split = url.split("/");
    var i = split.length - 1;
    url = split[i];
    $(".NavContainer nav ul li a").each(function () {
      var href = $(this).attr("href");
      if (href == url) {
        // var ids = href.split('#')
        // var id = "#"+ids[ids.length - 1]
        // $(this).attr('href', id)
      }
    });
  }

  // Add Heart
  function heartAddedFn() {
    $(".icon.heart").click(function () {
      $(this).toggleClass("is_added");
    });
  }

  //Smooth scroll click on <a> tag
  function smoothScrollingToSection() {
    $('.innerPageNavigation>ul>li>a[href^="#"]').click(function () {
      var target = $(this).attr("href");
      // $('.innerPageNavigation>ul>li>a.active').removeClass('active')
      // $(this).addClass('active')
      $("html, body").animate(
        {
          scrollTop:
            $($(this).attr("href")).offset().top -
            (headerHeight + innerPageNavHeight + 10),
        },
        100
      );
      return false;
    });
    $(window)
      .scroll(function () {
        var scrollDistance = $(window).scrollTop();
        $(".stickyArea > .sectionActive").each(function (i) {
          if (
            $(this).position().top - (headerHeight + innerPageNavHeight + 20) <=
            scrollDistance
          ) {
            $(".innerPageNavigation>ul>li>a.active").removeClass("active");
            $(".innerPageNavigation>ul>li>a").eq(i).addClass("active");
          }
        });
      })
      .scroll();
  }

  // Sticky
  function singlePackageSidebarSticky() {
    var nextHeightArray = [];
    $(".stickyArea")
      .nextAll()
      .each(function () {
        nextHeightArray.push($(this).outerHeight(true));
      });
    var nextHeightTotal = nextHeightArray.reduce(function (a, b) {
      return a + b;
    }, 0);
    nextHeightTotal = nextHeightTotal + (footerHeight ? footerHeight : 0);
    $("#sidebar_sticky").sticky({
      topSpacing: headerHeight,
      bottomSpacing: nextHeightTotal,
    });

    if (mobileOnly.matches) {
      $("#sidebar_sticky").unstick();
      if ($(".DesktopOnly").is("#sidebar_sticky")) {
        // $('#sidebar_sticky').unwrap()
        $(".DesktopOnly").removeAttr("id");
      }
    }
  }

  // Open Custom Package in Mobile
  function openCustomPackage() {
    if (tabsOnly.matches) {
      $(".bottomSticky .customizePackageCard_headWrap").on(
        "click",
        function (e) {
          // e.stoppropagation()
          $(".bottomSticky").toggleClass("is_hide");
          $(".icon", this).toggleClass("is_open");
        }
      );
      // $(".haveSubmenu").on("click", function () {
      //   // $(".haveSubmenu").removeClass('Active_MobileDropdown')
      //   $(this).find("ul").slideToggle(500, "linear");
      //   // $(this).toggleClass('Active_MobileDropdown')
      // });
    }
  }

  //Accordion
  function accordionFn() {
    $(".accordion")
      .find(".accordion__title")
      .click(function () {
        // Adds active class
        $(this).toggleClass("active");
        // Expand or collapse this panel
        $(this).next().slideToggle("fast");
        // Hide the other panels
        $(".accordion__content").not($(this).next()).slideUp("fast");
        // Removes active class from other titles
        $(".accordion__title").not($(this)).removeClass("active");
      });
  }

  // Tabs
  function tabsFn() {
    // Change tab class and display content
    $(".tabs-nav a").on("click", function (event) {
      event.preventDefault();

      $(".tab-active").removeClass("tab-active");
      $(this).parent().addClass("tab-active");
      $(".tabs-stage div").hide();
      $($(this).attr("href")).show();
    });

    $(".tabs-nav a:first").trigger("click"); // Default
  }

  function ecoHotelSlider() {
    $(".echoHotel_slider").slick({
      infinite: true,
      slidesToShow: 4,
      slidesToScroll: 1,
      arrows: true,
      autoplay: true,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
          },
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
          },
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
          },
        },
      ],
    });
  }

  function hotelImage_slider() {
    $(".hotelImage_slider").slick({
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      speed: 1400,
      autoplaySpeed: 2500,
      arrows: true,
      autoplay: true,
      fade: true,
      cssEase: "ease-in-out",
      lazyLoad: "ondemand",
      adaptiveHeight: true,
    });

    $(".hotelImage_slider .slick-arrow").click(function (e) {
      e.preventDefault();
    });
  }

  function ecoDestinationSlider() {
    $(".echoDestination_slider").slick({
      infinite: true,
      slidesToShow: 3,
      slidesToScroll: 1,
      arrows: true,
      autoplay: true,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
          },
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
          },
        },
      ],
    });
  }

  function ratingByGuestSlider() {
    $(".ratingByGuest_slider").slick({
      infinite: true,
      // slidesToShow: 1,
      // slidesToScroll: 1,
      speed: 1000,
      // autoplaySpeed: 8000,
      adaptiveHeight: true,
      arrows: true,
      autoplay: true,
      autoplaySpeed: 7000,
      fade: true,
      cssEase: "ease-in-out",
      touchThreshold: 600,
      lazyLoad: "ondemand",
      responsive: [
        {
          breakpoint: 767,
          settings: {
            adaptiveHeight: false,
          },
        },
      ],
    });
  }
  function cardImageSlider() {
    $(".card_imageSlider").slick({
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      speed: 1400,
      autoplaySpeed: 2500,
      arrows: true,
      autoplay: false,
      lazyLoad: "ondemand",
    });
  }

  function homePageCardImageSlider() {
    var cardHeight = $(
      ".leftImageSliderRightTextSliderCard .card_image"
    ).outerHeight();
    cardHeight = cardHeight / 2;
    if (mobileOnly.matches) {
      $(".leftImageSliderRightTextSliderCard .slick-arrow").css({
        top: cardHeight,
      });
    }

    // $('.homePageCard_imageSlider').slick({
    //   infinite: true,
    //   slidesToShow: 1,
    //   slidesToScroll: 1,
    //   speed: 1400,
    //   autoplaySpeed:4000,
    //   arrows: true,
    //   autoplay: true,
    //   lazyLoad: 'ondemand',
    //   adaptiveHeight: true,
    // });
  }

  function costPerPersonSlider() {
    $(".costPerPerson_slider").slick({
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      speed: 1400,
      autoplaySpeed: 4000,
      arrows: true,
      autoplay: true,
      lazyLoad: "ondemand",
    });
  }

  //Magnific popup Gallery
  function imageGalleryFn() {
    $(".ImageGalleryPopup").magnificPopup({
      type: "image",
      mainClass: "mfp-with-zoom",
      gallery: {
        enabled: true,
      },
      zoom: {
        enabled: false,
        duration: 300,
        easing: "ease-in-out",
        opener: function (openerElement) {
          // return openerElement.is('img') ? openerElement : openerElement.find('img');
          return openerElement;
        },
      },
    });
  }

  // loginRegistration Popup
  function loginRegistration() {
    $(".login, .signup, .customTourPackage, .forgot-password, .myAccountView").magnificPopup({
      closeBtnInside: true,
      closeOnBgClick: false,
    });
  }

  function bookNowFn() {
    $(".bookNowButton").magnificPopup({
      closeBtnInside: true,
      callbacks: {
        open: function () {
          var hotelName = $(".commonPopup_head>h3");
          $(".commonPopup_form input[name='data-hotel']").val(
            hotelName[0].innerHTML
          );
        },
        close: function () {
          $(".commonPopup_form input[name='data-hotel']").val(" ");
        },
      },
    });
  }

  // Disable past date
  function pastDateDisable() {
    // var checkInDate;
    let checkInDate;
    $(".checkIn").flatpickr({
      dateFormat: "d-m-Y",
      // minDate: new Date().fp_incr(1),
      minDate: "today",
      onChange: function (selectedDates, dateStr, instance) {
        //...
        checkInDate = selectedDates;
        checkOut(checkInDate[0]);
      },
    });
    function checkOut(date) {
      $(".checkOut").flatpickr({
        dateFormat: "d-m-Y",
        minDate: date ? date.fp_incr(1) : "today",
      });
    }
  }

  // Simple Marquee
  function impleMarqueeFn() {
    $(".simple-marquee-container").SimpleMarquee();
  }

  function PriceRangeFn() {
    $('.filterCheckboxCard input[type="checkbox"]').on("change", function () {
      $('input[name="' + this.name + '"]')
        .not(this)
        .prop("checked", false);
    });
  }

  // Map Loaction
  function initMap() {
    var map_canvas = document.getElementById("map_canvas");
    var lat;
    var lng;
    if (map_canvas != null) {
      // console.log("map_canvas", map_canvas.getAttribute("lat"));
      if (map_canvas.getAttribute("lat") != "") {
        lat = parseFloat(map_canvas.getAttribute("lat"));
      } else {
        lat = "";
      }
      if (map_canvas.getAttribute("lng") != "") {
        lng = parseFloat(map_canvas.getAttribute("lng"));
      } else {
        lng = "";
      }

      const latlng = { lat: lat, lng: lng };
      const map = new google.maps.Map(map_canvas, {
        zoom: 10,
        center: latlng,
      });
      const marker = new google.maps.Marker({
        position: latlng,
        map: map,
      });
    }
  }

  function InitMap2() {
    var map_canvas = document.getElementById("map_canvas");
    var lat;
    var lon;
    // position we will use later
    if (map_canvas != null) {
      if (map_canvas.getAttribute("lat") != "") {
        lat = parseFloat(map_canvas.getAttribute("lat"));
      } else {
        lat = "";
      }
      if (map_canvas.getAttribute("lng") != "") {
        lon = parseFloat(map_canvas.getAttribute("lng"));
      } else {
        lon = "";
      }
      // initialize map
      const map = L.map("map_canvas").setView([lat, lon], 13);
      // set map tiles source
      L.tileLayer("https://tile.openstreetmap.org/{z}/{x}/{y}.png", {
        attribution:
          'Map data &copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors',
        maxZoom: 18,
      }).addTo(map);
      // add marker to the map
      const marker = L.marker([lat, lon]).addTo(map);
      // add popup to the marker
      // marker.bindPopup("<b>ACME CO.</b><br />This st. 48<br />India").openPopup();
    }
  }

  function hotelFilterFn() {
    $("#filterHotel").submit(function () {
      var filter = $("#filterHotel");
      var priceRange, hotelCategory, propertyType;
      $('input[name="price_range[]"]:checked').each(function () {
        priceRange = this.value;
      });
      $('input[name="hotel_category[]"]:checked').each(function () {
        hotelCategory = this.value;
      });
      $('input[name="property_type[]"]:checked').each(function () {
        propertyType = this.value;
      });

      // var array = $.map($('input[name="property_type[]"]:checked'), function(c){return c.value; })
      //   $('input[name="property_type[]"]:checked').each(function() {
      //   });
      //   $('input[name="hotel_category[]"]:checked').each(function() {
      //  });
      $.ajax({
        // url:filter.attr('action'),
        url: window.location.href,
        data: {
          priceRange: priceRange,
          hotelCategory: hotelCategory,
          propertyType: propertyType,
        },
        type: filter.attr("method"), // POST
        beforeSend: function (xhr) {
          filter.find("button").text("Processing..."); // changing the button label
          // filter.find('button').attr("disabled", false);
        },
        success: function (data) {
          if (data) {
            filter.find("button").text("Apply filter");
          }
          $("#hotelFilter").html(data); // insert data
        },
        error: function (res) {
          console.log("err:", res);
        },
      });
      return false;
    });
  }

  // Increment Decrement
  function incrDecFn(addId, subsId) {
    $(addId).click(function add() {
      var $adult = $("#adult");
      var a = $adult.val();

      a++;
      $(subsId).prop("disabled", !a);
      $adult.val(a);
    });
    $(subsId).prop("disabled", !$("#adult").val());

    $(subsId).click(function subst() {
      var $adult = $("#adult");
      var b = $adult.val();
      if (b >= 2) {
        b--;
        $adult.val(b);
      } else {
        $(subsId).prop("disabled", true);
      }
    });
  }

  // Increment Decrement
  function incrDecFnFieChild() {
    $("#addChild").click(function add() {
      var $adult = $("#child");
      var a = $adult.val();

      a++;
      $("#subChild").prop("disabled", !a);
      $adult.val(a);
    });
    $("#subChild").prop("disabled", !$("#child").val());

    $("#subChild").click(function subst() {
      var $adult = $("#child");
      var b = $adult.val();
      if (b >= 1) {
        b--;
        $adult.val(b);
      } else {
        $("#subChild").prop("disabled", true);
      }
    });
  }

  function headerHotelSearch() {
    // $('.headerHotelSearchButton').click(function() {
    //   $('.hotelSearchButton_nav .headerSearchContainer').toggle().css({
    //     transform: 'scaleY(1)'
    //   })
    // })
    $('.headerHotelSearchButton').click(function() {
      $('.headerSearchContainer').toggleClass('headerSearchContainer_Active')
    })

    $(window).scroll(function() {
      if($(this).scrollTop() > 150) {
        $('.headerSearchContainer').removeClass('headerSearchContainer_Active');
      }
    })
  }

  // Gallery Single Page
  function gallerySinglePageFn() {
    $("#showGallerySinglePage").click(function (e) {
      e.preventDefault();
      var imageCount = $(this).attr("data-set");
      if (imageCount > 1) {
        $("html").css("overflow", "hidden");
        $(".gallerySinglePage").fadeIn();
        $(".gallerySinglePage").css({
          top: headerHeight,
        });
        $(".ImageGalleryBox .lazy").Lazy({
          scrollDirection: "vertical",
          effect: "fadeIn",
          visibleOnly: true,
          afterLoad: function (element) {
          },
          onError: function (element) {
            console.log("error loading image" + element.data("src"));
          },
        });
        // init Isotope
        var $grid = $('.isotopeGallery').isotope({
          itemSelector: '.gallery_item',
          percentPosition: true,
          layoutMode: 'masonry',
        });
        // layout Isotope after each image loads
        $grid.imagesLoaded().progress( function() {
          $grid.isotope('layout');
        });
        // var $grid = $(".isotopeGallery").isotope({
        //   itemSelector: '.gallery_item',
        //   layoutMode: 'masonry',
        //   percentPosition: true,
        //   stagger: 30,
        //   hiddenStyle: { transform: 'translateY(100px)', opacity: 0 },
        // });

      }
    });

    $(".gallerySinglePage #close").click(function (e) {
      e.preventDefault();
      $("html").css("overflow", "auto");
      $(".gallerySinglePage").fadeOut();
    });

    // Added Gallery Open to image clicks
    $("#overview .ImageGallerySection .ImageGalleryBox img").click(function (
      e
    ) {
      e.preventDefault();
      $("#showGallerySinglePage").click();
    });
  }
  // Gallery Isotope
  // var $grid = $('.isotopeGallery').isotope({
  //   itemSelector: '.gallery_item',
  //   layoutMode: 'fitRows'
  // });

  function galleryMainPageFn() {
    $(".galleryMainPage .lazy").Lazy({
      scrollDirection: "vertical",
      effect: "fadeIn",
      visibleOnly: true,
      threshold: 0,
      beforeLoad: function (e) {},
      afterLoad: function (element) {
        $(".galleryMainPage img.lazy").addClass("imgLoaded");
        var $grid = $(".galleryMainPage .isotopeGallery").isotope({
          itemSelector: ".gallery_item",
          layoutMode: "masonry",
          percentPosition: true,
          stagger: 30,
          hiddenStyle: { transform: "translateY(100px)", opacity: 0 },
        });
      },
      onError: function (element) {
        console.log("error loading image" + element.data("src"));
      },
    });
  }

  //Share icon show hide
  function shareIconFn() {
    $(".shareIcon").click(function (e) {
      e.stopPropagation();
      $(".a2a_kit").toggleClass("shareIcon_show");
    });

    $(document).click(function (e) {
      if ($(".a2a_kit").hasClass("shareIcon_show")) {
        if ($(e.target.hasClass !== $(".a2a_kit"))) {
          $(".a2a_kit").removeClass("shareIcon_show");
        }
      }
    });
  }

  // $(".wpcf7-submit").click(function(e){
  //   setTimeout(function(){
  //     $("div.wpcf7-response-output").fadeOut('slow');
  //   }, 3500)
  // })

  if ($(".wpcf7 form").hasClass("sent")) {
    setTimeout(function () {
      $("div.wpcf7-response-output").fadeOut("slow");
    }, 3500);
  }

  function customSelectFn() {
    var x, i, j, l, ll, selElmnt, a, b, c;
    /*look for any elements with the class "custom-select":*/
    x = document.getElementsByClassName("customSelect");
    l = x.length;
    for (i = 0; i < l; i++) {
      selElmnt = x[i].getElementsByTagName("select")[0];
      ll = selElmnt.length;
      /*for each element, create a new DIV that will act as the selected item:*/
      a = document.createElement("DIV");
      a.setAttribute("class", "select-selected");
      a.innerHTML = selElmnt.options[selElmnt.selectedIndex].innerHTML;
      x[i].appendChild(a);
      /*for each element, create a new DIV that will contain the option list:*/
      b = document.createElement("DIV");
      b.setAttribute("class", "select-items select-hide");
      for (j = 1; j < ll; j++) {
        /*for each option in the original select element,
        create a new DIV that will act as an option item:*/
        c = document.createElement("DIV");
        c.innerHTML = selElmnt.options[j].innerHTML;
        c.addEventListener("click", function (e) {
          /*when an item is clicked, update the original select box,
            and the selected item:*/
          var y, i, k, s, h, sl, yl;
          s = this.parentNode.parentNode.getElementsByTagName("select")[0];
          sl = s.length;
          h = this.parentNode.previousSibling;
          for (i = 0; i < sl; i++) {
            if (s.options[i].innerHTML == this.innerHTML) {
              s.selectedIndex = i;
              h.innerHTML = this.innerHTML;
              y = this.parentNode.getElementsByClassName("same-as-selected");
              yl = y.length;
              for (k = 0; k < yl; k++) {
                y[k].removeAttribute("class");
              }
              this.setAttribute("class", "same-as-selected");
              break;
            }
          }
          h.click();
        });
        b.appendChild(c);
      }
      x[i].appendChild(b);
      a.addEventListener("click", function (e) {
        /*when the select box is clicked, close any other select boxes,
          and open/close the current select box:*/
        e.stopPropagation();
        closeAllSelect(this);
        this.nextSibling.classList.toggle("select-hide");
        this.classList.toggle("select-arrow-active");
      });
    }
    function closeAllSelect(elmnt) {
      /*a function that will close all select boxes in the document,
      except the current select box:*/
      var x,
        y,
        i,
        xl,
        yl,
        arrNo = [];
      x = document.getElementsByClassName("select-items");
      y = document.getElementsByClassName("select-selected");
      xl = x.length;
      yl = y.length;
      for (i = 0; i < yl; i++) {
        if (elmnt == y[i]) {
          arrNo.push(i);
        } else {
          y[i].classList.remove("select-arrow-active");
        }
      }
      for (i = 0; i < xl; i++) {
        if (arrNo.indexOf(i)) {
          x[i].classList.add("select-hide");
        }
      }
    }
    /*if the user clicks anywhere outside the select box,
    then close all select boxes:*/
    document.addEventListener("click", closeAllSelect);
  }

  $(document).ready(function () {
    // Simple Marquee
    impleMarqueeFn();
    headerHeight();
    footerHeight();
    mobileMenu();
    activeNavbar();
    // currentLocation();
    heartAddedFn();
    // accordionFn();
    toOtherPageSpecificId();
    ecoHotelSlider();
    ecoDestinationSlider();
    ratingByGuestSlider();
    cardImageSlider();
    imageGalleryFn();
    tabsFn();
    smoothScrollingToSection();
    loginRegistration();
    homePageCardImageSlider();
    costPerPersonSlider();
    pastDateDisable();
    singlePackageSidebarSticky();
    openCustomPackage();
    PriceRangeFn();
    // hotelFilterFn();
    incrDecFn("#adds", "#subs");
    incrDecFnFieChild();
    headerHotelSearch();
    gallerySinglePageFn();
    hotelImage_slider();
    bookNowFn();
    shareIconFn();
    galleryMainPageFn();
    initMap();
    //

    // $("#hotelSearch").submit(function(e) {

    //   e.preventDefault();

    //   var form = $(this);
    //   var data = form.serialize();
    //   console.log("form:", form)
    //   console.log("data:", data)
    //   console.log("name:", $("#hotelSearch #serachHotel").val())

    // });

    // $("#catName").on('change', function(e){
    //   alert(this.value);
    //   console.log("valie:", this.value)
    // })
  }); //--End document.ready();
});
